import { DynamicImageComponent } from '../dynamic-image/dynamic-image.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfigService, UserService } from '../../services';
import { Component, Input } from '@angular/core';
import { User, strToUrl } from '../../models';

@Component({
    selector: 'user-image',
    template: require('./user-image.component.pug')
})
export class UserImageComponent extends DynamicImageComponent {
    @Input() width = 96;
    @Input() alt = false;

    private _baseUrl: string;
    user: User;

    constructor(private _configService: ConfigService,
                private _userService: UserService,
                _sanitizer: DomSanitizer) {
                super(_sanitizer);
        this._baseUrl = this._configService.getContext('management').url;
        let sub = this._userService.user$.subscribe(u => this.user = u);
    }

    get userImage(): string {
        if (!this.user || !this.user.isTokenValid) { return null; }
        let url =  `${this._baseUrl}/users/${strToUrl(this.user.tenant)}/${this.user.id}.jpg`;
        return url;
    }

    get name(): string {
        if (this.user) { return this.user.name; }
        return '';
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/user-image/user-image.component.ts